import axios from 'axios';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();
const serverUrl = () => process.env.REACT_APP_SERVER_URL_API || 'http://localhost:8090';

// Instance dédiée : pose son propre header Authorization à chaque requête en lisant
// le cookie directement, plutôt que de dépendre de l'intercepteur global posé par
// TokenContext.js (qui s'enregistre dans un useEffect du TokenProvider — un ancêtre
// de toute l'app — et peut donc s'exécuter après les effets des composants enfants
// qui appellent l'API dès leur montage, laissant partir des requêtes sans token).
const client = axios.create();
client.interceptors.request.use((config) => {
    const token = cookies.get('DASHBOARD_ACCESS');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const SERVICES = {
    SUPPORT: 'support_technique',
    COMMERCIAL: 'commercial',
};

export const PRIORITY_SERVICES = [SERVICES.SUPPORT];

export async function listTickets({ service, status, priority, page, limit } = {}) {
    const { data } = await client.get(`${serverUrl()}/api/tickets`, {
        params: { service, status, priority, page, limit }
    });
    return data;
}

export async function getTicketsSummary() {
    const { data } = await client.get(`${serverUrl()}/api/tickets/summary`);
    return data;
}

export async function getTicket(id) {
    const { data } = await client.get(`${serverUrl()}/api/tickets/${id}`);
    return data;
}

export async function createTicket({ title, description, service, priority, application, requestType, pageUrl }) {
    const payload = { title, description, service };
    if (priority) payload.priority = priority;
    if (application) payload.application = application;
    if (requestType) payload.request_type = requestType;
    if (pageUrl) payload.page_url = pageUrl;
    const { data } = await client.post(`${serverUrl()}/api/tickets`, payload);
    return data;
}

export async function updateTicketStatus(id, status) {
    const { data } = await client.patch(`${serverUrl()}/api/tickets/${id}/status`, { status });
    return data;
}

export async function listTicketMessages(id) {
    const { data } = await client.get(`${serverUrl()}/api/tickets/${id}/messages`);
    return data;
}

export async function addTicketMessage(id, content, attachments = []) {
    const { data } = await client.post(`${serverUrl()}/api/tickets/${id}/messages`, { content, attachments });
    return data;
}

export async function uploadTicketAttachments(id, files) {
    const form = new FormData();
    files.forEach(file => form.append('files', file));
    // Ne pas fixer Content-Type manuellement : le navigateur doit y ajouter le boundary multipart.
    const { data } = await client.post(`${serverUrl()}/api/tickets/${id}/attachments`, form);
    return data;
}

/**
 * Résout l'URL absolue d'une pièce jointe (le ticket-service renvoie des chemins relatifs /uploads/...).
 */
export function attachmentUrl(relativeUrl) {
    if (!relativeUrl) return '';
    if (relativeUrl.startsWith('http')) return relativeUrl;
    const ticketPublicUrl = process.env.REACT_APP_TICKET_SERVICE_PUBLIC_URL || 'http://localhost:3033';
    return `${ticketPublicUrl}${relativeUrl}`;
}
